module.exports = __webpack_public_path__ + "img/empty-customers.20ce2fe7.svg";